import { render } from "./CellTable.vue?vue&type=template&id=761f5980&scoped=true"
import script from "./CellTable.vue?vue&type=script&lang=js"
export * from "./CellTable.vue?vue&type=script&lang=js"

import "./CellTable.vue?vue&type=style&index=0&id=761f5980&lang=scss&scoped=true"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761f5980"]])

export default __exports__